import PropTypes from 'prop-types';

export default PropTypes.shape({ section_type: PropTypes.string });
